<div class="separacion">
  <img src="assets/areasIntegracion.png" alt="image" height="200" class="imagen-movil">
</div>
<div id="areasDeIntervencion" class="card-container col-12 row full-height">
  <div class="card-container row centrar areasDeIntervencionXS">
      <div class="col-12 col-lg-5 centrar separacion">
        <img src="assets/aprendizajeSignificativo.png" alt="image" height="400">
      </div>
      <div class="col-12 col-lg-7 centrar">
        <h1 class="titulo granate">Aprendizaje significativo</h1>
        <p>Cada estudiante aprende de manera diferente. No a todos nos resultan eficaces los mismos métodos, estrategias o técnicas para que nuestro aprendizaje sea significativo.</p><br>
        <p>Trabajo con cada niño o niña de manera personalizada, buscando qué es lo que motiva su aprendizaje, haciéndoles protagonista absoluto del mismo.</p><br>
        <p>Llevo a cabo técnicas de aprendizaje basadas en las teorías de pensamiento visual que desarrollan la atención, motivación y creatividad; y que se fundamentan en la importancia de la imagen en el cerebro y en el aprendizaje.</p><br>
      </div>
  </div>

  <div class="card-container row centrar areasDeIntervencionXS">
      <div class="col-12 col-lg-6">
        <h1 class="titulo granate">Apoyo psicopedagógico</h1>
        <ul>
          <li>
            <p style="margin-bottom: 0px;">Dificultades de aprendizaje</p>
            <ul>
              <li>
                <p style="margin-bottom: 0px;">Dislexia</p>
              </li>
              <li>
                <p style="margin-bottom: 0px;">Disgrafía</p>
              </li>
              <li>
                <p style="margin-bottom: 0px;">Disortografía</p>
              </li>
              <li>
                <p style="margin-bottom: 0px;">Discalculia</p>
              </li>
              <li>
                <p style="margin-bottom: 0px;">Retraso en lectoescritura</p>
              </li>
            </ul>
          </li>
          <li>
            <p style="margin-bottom: 0px;">Déficit de atención</p>
          </li>
          <li>
            <p style="margin-bottom: 0px;">Desmotivación y apatía</p>
          </li>
          <li>
            <p style="margin-bottom: 0px;">Problemas de autoestima</p>
            <ul>
              <li>
                <p style="margin-bottom: 0px;">Bajo autoconcepto</p>
              </li>
              <li>
                <p style="margin-bottom: 0px;">Sentimientos de incapacidad</p>
              </li>
            </ul>
          </li>
          <li>
            <p style="margin-bottom: 0px;">Problemas disruptivos</p>
            <ul>
              <li>
                <p style="margin-bottom: 0px;">Entorno familiar</p>
              </li>
              <li>
                <p style="margin-bottom: 0px;">Entorno escolar</p>
              </li>
            </ul>
          </li>
          <li>
            <p style="margin-bottom: 0px;">Problemas conductuales</p>
            <ul>
              <li>
                <p style="margin-bottom: 0px;">Dificultades de comunicación familiar</p>
              </li>
              <li>
                <p style="margin-bottom: 0px;">Dificultades de relación en el aula</p>
              </li>
              <li>
                <p style="margin-bottom: 0px;">Comportamientos negativos hacia la escuela</p>
              </li>
            </ul>
          </li>
          <li>
            <p style="margin-bottom: 0px;">Técnicas de estudio</p>
          </li>
          <li>
            <p style="margin-bottom: 0px;">Hábitos de vida</p>
            <ul>
              <li>
                <p style="margin-bottom: 0px;">Planificación del estudio</p>
              </li>
              <li>
                <p style="margin-bottom: 0px;">Organización de rutinas y actividades de la vida cotidiana</p>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="col-12 col-lg-6 separacion">
        <img src="assets/apoyoPsicopedagogico.png" alt="image" height="400">
      </div>
  </div>


  <div class="card-container row centrar areasDeIntervencionXS">
      <div class="col-12 col-lg-6 separacion">
        <img src="assets/orientacionEducativa.png" alt="image" height="400">
      </div>
      <div class="col-12 col-lg-6">
        <h1 class="titulo granate">ORIENTACIÓN EDUCATIVA</h1>
        <ul>
          <li>
            <p style="margin-bottom: 0px;">Orientación psicoeducativa</p>
            <ul>
              <li>
                <p style="margin-bottom: 0px;">Definición de estilo de aprendizaje</p>
              </li>
              <li>
                <p style="margin-bottom: 0px;">Adecuación del método de aprendizaje</p>
              </li>
              <li>
                <p style="margin-bottom: 0px;">Búsqueda de motivaciones</p>
              </li>
            </ul>
          </li>
          <li>
            <p style="margin-bottom: 0px;">Pautas psicoeducativas a familias</p>
            <ul>
              <li>
                <p style="margin-bottom: 0px;">Integración del estudio en la vida familiar</p>
              </li>
              <li>
                <p style="margin-bottom: 0px;">Rutinas y responsabilidades</p>
              </li>
              <li>
                <p style="margin-bottom: 0px;">Comunicación efectiva en la infancia y adolescencia</p>
              </li>
            </ul>
          </li>
          <li>
            <p style="margin-bottom: 0px;">Diagnóstico de necesidades educativas y trastornos de aprendizaje</p>
          </li>
          <li>
            <p style="margin-bottom: 0px;">Evaluaciones psicopedagógicas</p>
          </li>
          <li>
            <p style="margin-bottom: 0px;">Informes psicopedagógicos</p>
          </li>
          <li>
            <p style="margin-bottom: 0px;">Orientación académica</p>
            <ul>
              <li>
                <p style="margin-bottom: 0px;">Diseño de itinerarios educativos</p>
              </li>
              <li>
                <p style="margin-bottom: 0px;">Evaluación de preferencias formativas</p>
              </li>
            </ul>
          </li>
          <li>
            <p style="margin-bottom: 0px;">Orientación profesional</p>
            <ul>
              <li>
                <p style="margin-bottom: 0px;">Diseño de itinerarios laborales</p>
              </li>
              <li>
                <p style="margin-bottom: 0px;">Orientación laboral para la elaboración de curriculum</p>
              </li>
              <li>
                <p style="margin-bottom: 0px;">Preparación de entrevistas de trabajo</p>
              </li>
              <li>
                <p style="margin-bottom: 0px;">Evaluación de preferencias profesionales</p>
              </li>
            </ul>
          </li>
        </ul>
      </div>
  </div>

  <div class="card-container row centrar areasDeIntervencionXS">
    <div class="col-12 col-lg-6">
      <h1 class="titulo granate">APRENDIZAJE COOPERATIVO ENTRE IGUALES</h1>
      <div>
        <p style="margin-bottom: 0px;">Trabajo en pequeño grupo</p>
      </div>
      <ul>
          <li>
            <p style="margin-bottom: 0px;">Aprendizaje significativo</p>
          </li>
          <li>
            <p style="margin-bottom: 0px;">Tutoría entre iguales</p>
          </li>
          <li>
            <p style="margin-bottom: 0px;">Trabajo colaborativo</p>
          </li>
      </ul>
      <div>
        <p style="margin-bottom: 0px;">Trabajamos en grupos reducidos de dos o tres estudiantes que compartan aula durante la jornada escolar, para favorecer y reforzar los aprendizajes, fomentar el compañerismo, el aprendizaje colaborativo y cooperativo, así como la autonomía, la motivación y la empatía..</p>
        <p style="margin-bottom: 0px;">Este método favorece tanto a aquellos a los que les cuesta integrar los aprendizajes, como a los que tienen más facilidad pero falta de confianza.</p>
      </div>
    </div>
    <div class="col-12 col-lg-6 separacion">
      <img src="assets/aprendizajeCooperativo.png" alt="image" height="400" class="imagen-movil">
    </div>
</div>
</div>